import { SignatureRequestStatus } from "./interface";
import {
  getSignatureRequestStatusLabel,
  getSignatureRequestStatusPillStyle,
  SignatureStatusPillStyle,
} from "./reviewCtaUtils";

const SIGNATURE_STATUS_PILL_STYLES: Record<SignatureStatusPillStyle, string> = {
  pending: "bg-blue/10 text-blue",
  active: "bg-yellow/10 text-yellow",
  success: "bg-green/10 text-green",
  error: "bg-red/10 text-red",
  neutral: "bg-gray-100 text-gray-500",
  draft: "bg-gray-100 text-gray-500",
};

function SignatureRequestStatusIndicator({
  status,
  enableDraftRequests,
  t,
}: {
  status: SignatureRequestStatus;
  enableDraftRequests: boolean;
  t: (s: string) => string;
}) {
  if (status === "PENDING") {
    return (
      <span className="text-xs font-gilroy font-semibold text-gray-500 shrink-0">
        {t(enableDraftRequests ? "Draft" : "Waiting...")}
      </span>
    );
  }
  if (status === "REQUESTED") {
    return (
      <span className="text-xs font-gilroy font-semibold text-blue shrink-0">
        {t("Sent")}
      </span>
    );
  }

  const pillStyle = getSignatureRequestStatusPillStyle(status, enableDraftRequests);
  return (
    <div className={`text-xs font-gilroy font-semibold px-2 py-0.5 rounded-full shrink-0 ${SIGNATURE_STATUS_PILL_STYLES[pillStyle]}`}>
      {t(getSignatureRequestStatusLabel(status, enableDraftRequests))}
    </div>
  );
}

export default SignatureRequestStatusIndicator;
